// Generated by purs version 0.13.0
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Char = require("../Data.Char/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Ritoppu_Model_Equipment = require("../Ritoppu.Model.Equipment/index.js");
var Ritoppu_Model_Item = require("../Ritoppu.Model.Item/index.js");
var initInventory = Data_Map_Internal.fromFoldable(Ritoppu_Model_Item.ordItem)(Data_Foldable.foldableArray)([ new Data_Tuple.Tuple(Ritoppu_Model_Item.HealingPotion.value, 3), new Data_Tuple.Tuple(Ritoppu_Model_Item.LightningScroll.value, 5), new Data_Tuple.Tuple(Ritoppu_Model_Item.FireballScroll.value, 2), new Data_Tuple.Tuple(Ritoppu_Model_Item.ConfusionScroll.value, 3), new Data_Tuple.Tuple(new Ritoppu_Model_Item.MainHandItem(Ritoppu_Model_Equipment.Dagger.value), 1), new Data_Tuple.Tuple(new Ritoppu_Model_Item.MainHandItem(Ritoppu_Model_Equipment.Sword.value), 1), new Data_Tuple.Tuple(new Ritoppu_Model_Item.OffHandItem(Ritoppu_Model_Equipment.Shield.value), 1) ]);
var alphabet = Data_Functor.map(Data_Functor.functorArray)((function () {
    var $0 = Data_Maybe.fromMaybe("a");
    return function ($1) {
        return Data_String_CodeUnits.singleton($0(Data_Char.fromCharCode($1)));
    };
})())(Data_Array.range(Data_Char.toCharCode("a"))(Data_Char.toCharCode("z")));
var inventoryPositions = (function () {
    var $2 = Data_Map_Internal.fromFoldable(Data_Ord.ordString)(Data_Foldable.foldableArray);
    var $3 = Data_Array.zip(alphabet);
    var $4 = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
    return function ($5) {
        return $2($3($4($5)));
    };
})();
module.exports = {
    initInventory: initInventory,
    inventoryPositions: inventoryPositions
};
